import styled from 'styled-components'
import { Layout } from 'antd'

const StyledLayout = styled(Layout)`
  background: ${props => props.theme.bgLight};
  min-height: 100vh;
  padding: 0;
`
export { StyledLayout }
